import React from 'react'
import { Route } from 'react-router-dom'

import Home from './Home'

import ProgramsContainer from '../overview/ProgramsContainer'
import LocationsContainer from '../overview/LocationsContainer'
import ServicesContainer from '../overview/ServicesContainer'

import AddBatchContainer from '../report-entry/AddBatchContainer'
import AddProductsContainer from '../report-entry/AddProductsContainer'
import FindReportContainer from '../report-entry/FindReportContainer'
import ReportEntryContainer from '../report-entry/ReportEntryContainer'
import ReportViewContainer from '../report-entry/ReportViewContainer'
import ConfirmationContainer from '../confirmation/ConfirmationContainer'
import SuccessContainer from '../success/SuccessContainer'
import LedgerContainer from '../ledger/LedgerContainer'
import TransferContainer from '../transfer/TransferContainer'
import SalesStatementContainer from '../statements/SalesStatementContainer'
import InventoryStatementContainer from '../statements/InventoryStatementContainer'

const Routes = ({ api, rootHistory, showCountSyncBanner, showShipmentSyncBanner, basename = '' }) => (
  <div className='van-stock-count'>
    <Route exact
      path={basename}
      component={Home}
    />

    <Route exact
      path={`${basename}/programs/:locationId/:date`}
      render={(props) => <ProgramsContainer {...props} rootHistory={rootHistory} showCountSyncBanner={showCountSyncBanner} showShipmentSyncBanner={showShipmentSyncBanner} />}
    />

    <Route exact
      path={`${basename}/locations/:locationId/:date/:programId`}
      render={(props) => <LocationsContainer {...props} api={api} rootHistory={rootHistory} showCountSyncBanner={showCountSyncBanner} showShipmentSyncBanner={showShipmentSyncBanner} />}
    />

    <Route exact
      path={`${basename}/services/:locationId/:date/:programId/:reportLocationId/:partialCount?`}
      component={ServicesContainer}
    />

    <Route exact
      path={`${basename}/find-report/:locationId/:serviceId/:date/:productId?/:partialCount?`}
      component={FindReportContainer}
    />

    <Route exact
      path={`${basename}/report/:reportId/:productId?`}
      component={ReportEntryContainer}
    />

    <Route exact
      path={`${basename}/report/:reportId/:productId/add-batch/:expiryForm?`}
      component={AddBatchContainer}
    />

    <Route exact
      path={`${basename}/add-products/:reportId`}
      component={AddProductsContainer}
    />

    <Route exact
      path={`${basename}/confirmation/:reportId`}
      component={ConfirmationContainer}
    />

    <Route exact
      path={`${basename}/view/:reportId/:productId?`}
      component={ReportViewContainer}
    />

    <Route exact
      path={`${basename}/sales-statement/:locationId/:serviceId/:date/:reportId`}
      component={SalesStatementContainer}
    />

    <Route exact
      path={`${basename}/inventory-statement/:locationId/:serviceId/:date/:reportId`}
      component={InventoryStatementContainer}
    />

    <Route exact
      path={`${basename}/success/:locationId`}
      render={(props) => <SuccessContainer {...props} rootHistory={rootHistory} />}
    />

    <Route exact
      path={`${basename}/ledger/:serviceId/:locationId/:productId`}
      render={(props) => <LedgerContainer {...props} rootHistory={rootHistory} />}
    />

    <Route exact
      path={`${basename}/transfer/:serviceId/:locationId/:productId`}
      render={(props) => <TransferContainer {...props} rootHistory={rootHistory} />}
    />

  </div>
)

export default Routes
